import {
    VRCORE_GET_JOB_PACKS,
    VRCORE_JOB_PACK_PROFILE_SELECTED_INDEX,
    VRCORE_PROFILE_EDIT_SELECTED_TAB,
    VRCORE_POST_EDITED_USER,
    VRCORE_REMOVE_JOB_PACK,
    VRCORE_GET_TEMPLATES,
    GET_REPORT_TITLES,
    VRCORE_GET_ALL_USERS,
    VRCORE_UPLOAD_FILE,
    VRCORE_REMOVE_FILE,
    VRCORE_SET_FILES
} from "./types";
import { push } from "connected-react-router";
import firebase from "firebase/app";
export const uploadFile = (jobName = false, filename = false) => {
    return dispatch => {
        dispatch({
            type: VRCORE_UPLOAD_FILE.REQUEST
        });
        if (jobName && filename)
            try {
                firebase
                    .storage()
                    .ref(`files/${jobName}/`)
                    .child(filename)
                    .getDownloadURL()
                    .then(url => {
                        let file = {
                            file: filename,
                            fileURL: url
                        };

                        dispatch({
                            type: VRCORE_UPLOAD_FILE.SUCCESS,
                            payload: file
                        });
                    });
            } catch (e) {
                dispatch({
                    type: VRCORE_UPLOAD_FILE.FAIL
                });
            }
        else
            dispatch({
                type: VRCORE_UPLOAD_FILE.FAIL
            });
    };
};
export const removeFile = (jobName = false, filename = false, files = false, i = false) => {
    return dispatch => {
        dispatch({
            type: VRCORE_REMOVE_FILE.REQUEST
        });
        if (jobName && filename && files && i)
            try {
                const index = files.indexOf(i);
                if (files.length > 1) files.splice(index, 1);
                else files = [];
                firebase
                    .storage()
                    .ref(`files/${jobName}/`)
                    .child(filename)
                    .delete()
                    .then(function() {
                        dispatch({
                            type: VRCORE_REMOVE_FILE.SUCCESS,
                            payload: files
                        });
                        // File deleted successfully
                    })
                    .catch(function(error) {
                        // Uh-oh, an error occurred!
                    });
            } catch (e) {
                dispatch({
                    type: VRCORE_REMOVE_FILE.FAIL
                });
            }
        else
            dispatch({
                type: VRCORE_REMOVE_FILE.FAIL
            });
    };
};
export const setUploadedFiles = (files = false) => {
    return dispatch => {
        dispatch({
            type: VRCORE_SET_FILES.REQUEST
        });
        if (files)
            try {
                if (typeof files === "undefined") files = [];
                dispatch({
                    type: VRCORE_SET_FILES.SUCCESS,
                    payload: files
                });
            } catch (e) {
                dispatch({
                    type: VRCORE_SET_FILES.FAIL
                });
            }
        else
            dispatch({
                type: VRCORE_SET_FILES.FAIL
            });
    };
};
export const getJobPack = (id = false) => {
    return dispatch => {
        dispatch({
            type: VRCORE_GET_JOB_PACKS.REQUEST
        });
        if (id)
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({
                            type: VRCORE_GET_JOB_PACKS.FAIL
                        });
                    } else {
                        firebase
                            .database()
                            .ref("/subjects/job_packs/" + id)
                            .on("value", snapshot => {
                                dispatch({
                                    type: VRCORE_GET_JOB_PACKS.SUCCESS,
                                    payload: snapshot.val()
                                });
                            });
                    }
                });
            } catch (e) {
                dispatch({
                    type: VRCORE_GET_JOB_PACKS.FAIL
                });
            }
        else
            dispatch({
                type: VRCORE_GET_JOB_PACKS.FAIL
            });
    };
};
export const getReportTitles = () => {
    return dispatch => {
        dispatch({
            type: GET_REPORT_TITLES.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: GET_REPORT_TITLES.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("collections/report_titles")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: GET_REPORT_TITLES.FAIL
            });
        }
    };
};
export const gotolink = url => {
    return dispatch => {
        dispatch(push(url));
    };
};
export const removeJobPack = (job = false) => {
    return dispatch => {
        dispatch({ type: VRCORE_REMOVE_JOB_PACK.REQUEST });
        if (job)
            try {
                job.deleted = true;
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({ type: VRCORE_REMOVE_JOB_PACK.FAIL });
                    } else {
                        firebase
                            .database()
                            .ref(`/subjects/job_packs/${job.job_id}/profile`)
                            .set(job);
                    }
                });
            } catch (e) {
                dispatch({ type: VRCORE_REMOVE_JOB_PACK.FAIL });
            }
        else dispatch({ type: VRCORE_REMOVE_JOB_PACK.FAIL });
    };
};
export const setSelectedJobPackIndex = index => {
    return dispatch => {
        dispatch({
            type: VRCORE_JOB_PACK_PROFILE_SELECTED_INDEX,
            payload: index
        });
    };
};
export const setSelectedTab = index => {
    return dispatch => {
        dispatch({
            type: VRCORE_PROFILE_EDIT_SELECTED_TAB,
            payload: index
        });
    };
};

export const postEditedJobPack = (job_pack = false, uuid = false) => {
    return dispatch => {
        dispatch({
            type: VRCORE_POST_EDITED_USER.REQUEST
        });
        if (job_pack && uuid)
            try {
                firebase.auth().onAuthStateChanged(user => {
                    if (user === null) {
                        dispatch({
                            type: VRCORE_POST_EDITED_USER.FAIL
                        });
                    } else {
                        firebase
                            .database()
                            .ref(`/subjects/job_packs/${uuid}/profile`)
                            .set(job_pack, snapshot => {
                                dispatch({ type: VRCORE_POST_EDITED_USER.SUCCESS });
                            });
                    }
                });
            } catch (e) {
                dispatch({
                    type: VRCORE_POST_EDITED_USER.FAIL
                });
            }
        else
            dispatch({
                type: VRCORE_POST_EDITED_USER.FAIL
            });
    };
};
export const getTemplates = () => {
    return dispatch => {
        dispatch({ type: VRCORE_GET_TEMPLATES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: VRCORE_GET_TEMPLATES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/job_templates")
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_TEMPLATES.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: VRCORE_GET_TEMPLATES.FAIL });
        }
    };
};
export const getAllUsers = () => {
    return dispatch => {
        dispatch({
            type: VRCORE_GET_ALL_USERS.REQUEST
        });
        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({
                        type: VRCORE_GET_ALL_USERS.FAIL
                    });
                } else {
                    firebase
                        .database()
                        .ref("users")
                        .on("value", snapshot => {
                            dispatch({
                                type: VRCORE_GET_ALL_USERS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({
                type: VRCORE_GET_ALL_USERS.FAIL
            });
        }
    };
};
